var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHoveredGarbageCan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.334 2.99992H13.1673C13.4435 2.99992 13.6673 3.22378 13.6673 3.49992V3.83325C13.6673 4.10939 13.4435 4.33325 13.1673 4.33325H12.334V12.9999C12.334 13.1767 12.2637 13.3463 12.1387 13.4713C12.0137 13.5963 11.8441 13.6666 11.6673 13.6666H2.33398C2.15717 13.6666 1.9876 13.5963 1.86258 13.4713C1.73756 13.3463 1.66732 13.1767 1.66732 12.9999V4.33325H0.833985C0.557842 4.33325 0.333984 4.10939 0.333984 3.83325V3.49992C0.333984 3.22378 0.557842 2.99992 0.833984 2.99992H3.66732V0.999919C3.66732 0.823108 3.73756 0.653538 3.86258 0.528514C3.9876 0.40349 4.15717 0.333252 4.33398 0.333252H9.66732C9.84413 0.333252 10.0137 0.40349 10.1387 0.528514C10.2637 0.653538 10.334 0.823108 10.334 0.999919V2.99992ZM11.0007 4.33325H3.00065V12.3333H11.0007V4.33325ZM5.00065 1.66659V2.99992H9.00065V1.66659H5.00065Z",
    fill: "#7DCDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 4.33325H3.00065V12.3333H11.0007V4.33325Z",
    fill: "#7DCDED"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHoveredGarbageCan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hoveredGarbageCan.e85b286c.svg";
export { ForwardRef as ReactComponent };